/**
 * The discount a new contract is written with (BL-20). The form starts from the shop's standard
 * discount, raised to the client's card category percentage (`GET
 * /contracts/default-discount/:clientId`); the operator may change it, as in Delphi.
 */

/** Upper bound of the discount, in percent; the server checks the same. */
export const MAX_DISCOUNT_PERCENT = 100;

/**
 * The typed discount as the server stores it: a whole percentage from 0 to 100. A value outside
 * the range is held at its nearest end, and one that is not a number counts as 0.
 */
export const clampDiscountPercent = (value: number): number =>
    Number.isFinite(value) ? Math.min(MAX_DISCOUNT_PERCENT, Math.max(0, Math.round(value))) : 0;
